export default "__VITE_ASSET__CKH53MUd__"